import Axios from "@/plugins/Axios";

export class UsabilidadeService {
  async getProfessoresUsabilidade(configuracao_id) {
    const response = await Axios().get(`usabilidade/professores-usabilidade/${configuracao_id}`);
    return response.data.franquiaComGestoes;
  }

  async getCoordenadorUsabilidade(configuracao_id) {
    const response = await Axios().get(`usabilidade/coordenador-usabilidade/${configuracao_id}`);
    return response.data.franquiaComGestoes;
  }

  async getAlunosUsabilidade(configuracao_id) {
    const response = await Axios().get(`usabilidade/alunos-usabilidade/${configuracao_id}`);
    return response.data.franquiaComTurmas;
  }
}
export default new UsabilidadeService();
